import React from "react";
import ReactApexChart from "Components/common/SafeApexChart";
import { getNiceMax } from "../utils/chartDataUtils";

const METRICS = [
  { label: "Connections Sent",     key: "connectionsSent" },
  { label: "Connections Accepted", key: "connectionsAccepted" },
  { label: "Messages Sent",        key: "messagesSent" },
  { label: "Messages Replied",     key: "messagesReplied" },
  { label: "Profiles Viewed",      key: "profileViewed" }
];

const LinkedInOverviewWidget = ({ data = {} }) => {
  const labels = METRICS.map(m => m.label);
  const counts = METRICS.map(m => data[m.key] || 0);
  const { max: niceMax, tickAmount } = getNiceMax(Math.max(...counts, 1));

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: false },
      selection: { enabled: false },
      zoom: { enabled: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 3,
        columnWidth: "55%",
        distributed: true
      }
    },
    colors: ["#16a34a"],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: labels,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      min: 0,
      max: niceMax,
      tickAmount,
      labels: {
        formatter: val => Math.round(val),
        style: { fontSize: "10px", colors: "#999" }
      }
    },
    grid: {
      borderColor: "#e8ebee",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    tooltip: {
      x: { show: true },
      y: { formatter: val => `${val}` }
    }
  };

  const series = [{ name: "Count", data: counts }];

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={140}
      width="100%"
    />
  );
};

export default LinkedInOverviewWidget;
